import { parse } from 'query-string';
class UserPreviewState {
    constructor() {
        const { search } = window.location;
        const queryObject = parse(search) || {};
        this.previewValue = queryObject.preview;
        this.isPreview = !!this.previewValue;
    }
}
// singleton
export default new UserPreviewState();
